import { SupportedLocales } from "@/types/Producer";

type LocaleConfiguration = "default" | "maracana" | "lnf" | "max" | "cluberun";
type LocaleMessages = Record<SupportedLocales, Record<string, unknown>>;

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

function deepMerge(base: Record<string, unknown>, override: Record<string, unknown>): Record<string, unknown> {
  const result: Record<string, unknown> = { ...base };

  for (const key of Object.keys(override)) {
    const baseValue = result[key];
    const overrideValue = override[key];

    result[key] = isPlainObject(baseValue) && isPlainObject(overrideValue)
      ? deepMerge(baseValue, overrideValue)
      : overrideValue;
  }

  return result;
}

const base: LocaleMessages = {
  "en": {},
  "es": {},
  "pt-br": {
    entities: {
      ticket: "Ingresso | Ingressos",
      type: "Tipo de Ingresso",
    },
    actions: {
      ticket: {
        view: "Visualizar Ingresso",
        save: "Salvar Ingresso",
        saveAll: "Salvar Todos os Ingressos",
      },
    },
    menu: {
      tickets: "Meus Ingressos",
    },
    event: {
      buy: "Comprar Ingressos",
      soon: "Vendas em Breve",
      closed: "Vendas Encerradas",
      opening: "Abertura dos Portões",
    },
    checkout: {
      steps: {
        choice: {
          short: "Escolha de Produtos",
          complete: "Escolha de Produtos",
        },
      },
    },
    support: {
      eventFieldLabel: "Jogo / Evento",
      eventSubjectLabel: "Informações sobre o Jogo/Evento",
    },
  },
};

const overrides: Partial<Record<Exclude<LocaleConfiguration, "default">, Partial<LocaleMessages>>> = {
  maracana: {
    "pt-br": {
      entities: {
        ticket: "Produto | Produtos",
        type: "Produto",
      },
      actions: {
        ticket: {
          view: "Visualizar Produtos",
          save: "Salvar",
          saveAll: "Salvar Todos",
        },
      },
      menu: {
        tickets: "Meus Produtos",
      },
      event: {
        buy: "Comprar",
        opening: "Abertura do Club",
      },
    },
  },
  max: {
    "pt-br": {
      support: {
        eventFieldLabel: "Evento",
        eventSubjectLabel: "Informações sobre o Evento",
      },
    },
  },
  cluberun: {
    "pt-br": {
      event: {
        buy: "Fazer Inscrição",
        soon: "Inscrições em Breve",
        closed: "Inscrições Encerradas",
      },
    },
  },
};

const configuration: Record<LocaleConfiguration, LocaleMessages> = {
  default: base,
  lnf: deepMerge(base, overrides.lnf ?? {}) as LocaleMessages,
  maracana: deepMerge(base, overrides.maracana ?? {}) as LocaleMessages,
  max: deepMerge(base, overrides.max ?? {}) as LocaleMessages,
  cluberun: deepMerge(base, overrides.cluberun ?? {}) as LocaleMessages,
};

export { configuration };
